export default __webpack_public_path__ + "static/media/GM_Bowl_Ancient.bdbb9320.png";